import ApiService from "../../services/apiService";
import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDoorOpen,
  faWifi,
  faBatteryThreeQuarters,
  faSun,
  faTemperatureLow,
} from "@fortawesome/free-solid-svg-icons";
import ValveCompponent from "./ValveComponent";
import { format } from "date-fns";
import ProgressBar from "./ProgressBar";
import ScheduelPopup from "./ScheduelPopup";
import Calendar from "../calendar/Calendar";
import CalendarIcon from "../svg/Calendar";
import ScheduleIcon from "../svg/Schedule";
import Diagram from "../svg/Diagram";

import ConcreteBed from "./Water_irrigation_Version03/Concrete_bed2.png.svg";
import mainLine from "./Water_irrigation_Version03/Main_line_Red.svg.svg";
import P1 from "./Water_irrigation_Version03/P1.svg";
import P2 from "./Water_irrigation_Version03/P2.svg";
import P3 from "./Water_irrigation_Version03/P3.svg";
import P5 from "./Water_irrigation_Version03/P4.svg";
import P2_R from "./Water_irrigation_Version03/P2_R.svg";
import P2_G from "./Water_irrigation_Version03/P2_G.svg";
import antena from "./version03/Water_irrigation_Version03/Pole_antenna.png";
import Water_meter from "./version03/Water_irrigation_Version03/Water_Metre.svg";
import pressure_meter from "./version03/Water_irrigation_Version03/Pressure_Metre.svg";
import SubChak from "./SubChak";
import ChakSvg from "../svg/ChakSvg";
import { Color } from "highcharts";
import mainpipleline from "./version03/Water_irrigation_Version03/main_Pipeline.svg";
import mainlinered from "./version03/Water_irrigation_Version03/Main_line_red.svg";
import { useAppSelector } from "../../reduxToolkit/hooks";

const ChackComponent = ({
  id,
  onClose,
  selectedChildOms,
}: {
  id: any;
  onClose: any;
  selectedChildOms?: any;
}) => {
  const elapsedRef = useRef<number>(0);
  const intervalId = useRef<NodeJS.Timeout | null>(null);
  const hasStoredResponse = useRef<boolean>(false);
  const firstResponseRef = useRef<number>(0);
  const lastResponseRef = useRef<number>(0);
  const progressInterval = useRef<NodeJS.Timeout | null>(null);
  const [firstResponse, setFirstResponse] = useState<number>();

  const [chackData, setChackData] = useState<any>([]);
  const [valveData, setValveData] = useState<any>([]);
  const [numberOfValve, setNumberOfValve] = useState<any>([]);
  const [interrogate, setInterrogate] = useState<number>(0);
  const [roms, setRoms] = useState<number>(0);
  const [progressBar, setProgressBar] = useState<boolean>(false);
  const [lastResponse, setLastResponse] = useState<number>();
  const [now, setNow] = useState<number>(0);
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
  const [selectedComponent, setSelectedComponent] = useState<string>();
  const [selectedButton, setSelectedButton] = useState<boolean>(false);
  const [selectedPfcmd, setSelectedPfcmd] = useState<string>("");
  const [subChakData, setSubChakData] = useState<any[]>([]);
  const role = useAppSelector((state: any) => state.role.role);

  const gradientStyle = {
    background: "linear-gradient(#b4ffee, #dffff8)", // Gradient from red to yellow
    padding: "6px 0px", // Padding for some spacing inside the element
  };

  useEffect(() => {
    const fetchChack = async () => {
      try {
        const response = await ApiService.axiosApi(`/chack/${id}`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          const data = response.data;

          const final = Array.isArray(data) ? data : [data];

          setChackData(final);
        } else {
          toast.error("unable to load details");
          console.log(response.message || "getting problem in fetching api ");
        }
      } catch (error: any) {
        console.log(error);
      }
    };
    fetchChack();

    // fetching valve detail

    const fetchValve = async () => {
      try {
        const response = await ApiService.axiosApi(
          `/chackvalvedetail/chackid${id}`,
          {
            method: "GET",
          },
        );
        if (response.success) {

          setNumberOfValve(response.data);
        } else {
          console.log(response.message || "unable to fetch valve details");
        }
      } catch (error: any) {
        console.log(error);
      }
    };
    fetchValve();

    const chackInterval = setInterval(fetchChack, 10000);

    const valveInterval = setInterval(fetchValve, 10000);

    return () => {
      clearInterval(chackInterval);

      clearInterval(valveInterval);
    };
  }, [id]);

  /*const valveWidht = 44
     const pipeWidth = (valveCount: number) => (valveCount * valveWidht)

     const valveLine1 = numberOfValve.filter((valve: any) => valve.line === 1)
     const valveLine2 = numberOfValve.filter((valve: any) => valve.line === 2)*/

  //progressbar
  const startProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }

    setNow(0);
    setProgressBar(true);

    const stepTime = 250;
    const duration = 45000;
    const increment = 100 / (duration / stepTime);
    let current = 0;

    progressInterval.current = setInterval(() => {
      current += increment;
      if (current >= 100) {
        current = 100;
        clearInterval(progressInterval.current!);
        progressInterval.current = null;
      }
      setNow(current);
    }, stepTime);
  };

  const stopProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }
    setNow(0);
    setProgressBar(false);
  };


  const sendIntgCommnad = async () => {
    startProgressBar();
    try {
      const response = await ApiService.axiosApi(`/command/intg`, {
        method: "POST",
        data: {
          chakId: id,
          command: "INTG",
        },
      });
      if (response.success) {
        toast.success("Success");
      } else {
        toast.error("Failed");
      }
    } catch (e) {
      console.log(e);

    } finally {
      stopProgressBar();
    }
  };

  const sendAutoManualCommnad = async (data: any) => {
    startProgressBar();
    try {
      const response = await ApiService.axiosApi(`/command/auto/manual`, {
        method: "POST",
        data: {
          deviceId: id,
          autoManual: data.romsAuto ? 0 : 1,
        },
      });
      if (response.success) {
        toast.success("Success");
      } else {
        toast.error("Failed");
      }
    } catch (e) {
      console.log(e);
    } finally {
      stopProgressBar();
    }
  };

  return (
    <>
      {progressBar && (
        <ProgressBar
          totalpage={0}
          pageNumber={0}
          now={now}
          mystyle={{
            position: "absolute",
            height: "25px",
            zIndex: 1000,
            backgroundColor: "whitesmoke",
            borderRadius: "4px",
            top: "-30px",
            padding: "0px 4px",
            width: "100%",
          }}
        />
      )}

      {chackData.length > 0 && chackData[0].deviceType == "DMS" && (
        <div className="modal-content d-xl-flex">
          {chackData.map((data: any) => (
            <>
              <div className="modal-header" style={gradientStyle} key={data.id}>
                <div className="col-md-12">
                  <div className="row justify-content-between">
                    <div className="col-md-4">
                      <h5
                        className="modal-title "
                        style={{ color: "GrayText" }}
                      >
                        <strong>{data.chackName}</strong>
                      </h5>
                    </div>

                    <div className="col-md-7 text-end pt-1 px-4 d-flex justify-content-end align-items-center ">
                      {selectedComponent == "CalendarComponent" ? (
                        <div
                          onClick={() => {
                            setSelectedComponent("ChakComponent");
                          }}
                          style={{ zIndex: 10 }}
                          className="Calendar-Button me-1"
                        >
                          <Diagram />
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            setSelectedComponent("CalendarComponent");
                            setSelectedPfcmd("");
                          }}
                          style={{ zIndex: 10 }}
                          className="Calendar-Button me-1"
                        >
                          <CalendarIcon />
                        </div>
                      )}

                      {role != "Administrator" ? (
                        ""
                      ) : (
                        <>
                          <Button
                            color="primary me-1"
                            onClick={() => {
                              sendIntgCommnad();
                            }}
                            style={{ zIndex: 10 }}

                          >
                            Interrogate
                          </Button>
                        </>
                      )}
                      {role != "Administrator" ? (
                        ""
                      ) : (
                        <>
                          <Button
                            size="md"
                            color={`${data.romsAuto ? "danger" : "primary"}`}
                            onClick={() => sendAutoManualCommnad(data)}

                          >
                            {data.romsAuto ? "Roms Auto" : "Roms Manual"}
                          </Button>
                        </>
                      )}
                      <button
                        className="chackbutton"
                        onClick={onClose}
                        style={{}}
                      >
                        X
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-body" style={{ width: "100%" }}>
                {selectedComponent == "CalendarComponent" ? (
                  <Calendar ChakId={data.id} />
                ) : selectedComponent == "ScheduleComponent" ? (
                  <ScheduelPopup
                    totalValves={data.no_Of_ON_OF_Valves}
                    ChakId={data.id}
                  />
                ) : (
                  <div className="row" style={{ width: "100%" }}>
                    <div
                      className="col-md-1 "
                      style={{ borderRight: "0.5px inset grey", height: "50%" }}
                    >
                      <ul className="pop-icons justify-content-center align-items-center">
                        <li
                          className={`d-flex flex-column align-items-center justify-content-center pb-4  ${
                            data.door1 == "Open" ? "red" : "green"
                          }`}
                        >
                          <div className="">
                            <FontAwesomeIcon icon={faDoorOpen} size="2x" />
                          </div>
                          <div className="">
                            {data.door1 == "Open" ? "Open" : "Close"}
                          </div>
                        </li>

                        <li
                          className={`pb-4  d-flex flex-column align-items-center justify-content-center  ${
                            data.networkStatus == "Good"
                              ? "green"
                              : data.networkStatus == "Excellent"
                                ? "green"
                                : data.networkStatus == "Average"
                                  ? "network-yellow"
                                  : "red"
                          }`}
                        >
                          <div className="">
                            <FontAwesomeIcon icon={faWifi} size="2x" />
                          </div>
                          <div className="">{data.networkStatus}</div>
                        </li>

                        <li
                          className={`pb-4 d-flex  d-flex flex-column align-items-center justify-content-center ${
                            data.battery < 20 ? "red" : "green"
                          }`}
                        >
                          <div className="">
                            <FontAwesomeIcon
                              icon={faBatteryThreeQuarters}
                              size="2x"
                            />
                          </div>
                          <div className="">{`${data.battery}%`}</div>
                        </li>

                        <li className="green pb-4  align-items-center d-flex flex-column justify-content-center ">
                          <div className="">
                            <FontAwesomeIcon icon={faSun} size="2x" />
                          </div>
                          <div className="">{`${data.solarVoltage}V`}</div>
                        </li>

                        <li className="green d-flex flex-column align-items-center justify-content-center">
                          <div className="">
                            <FontAwesomeIcon
                              icon={faTemperatureLow}
                              size="2x"
                            />
                          </div>
                          <div className="">{`${data.temprature}°C`}</div>
                        </li>
                      </ul>
                    </div>

                    <div className="col-md-8">
                      {selectedComponent == "SubChak" ||
                      selectedChildOms == "childoms" ? (
                        <SubChak data={numberOfValve} chackData={chackData} />
                      ) : (
                        <div className="" id="valve-component">
                          <img
                            id="antena_pole"
                            loading="lazy"
                            src={antena}
                            alt=""
                            style={{
                              height: "500px",
                              width: "400px",
                              position: "absolute",
                              zIndex: 3,
                              top: "-60px",
                              left: "450px",
                            }}
                          />
                          <img
                            id="water-meter"
                            loading="lazy"
                            src={Water_meter}
                            alt=""
                            style={{
                              height: "40px",
                              width: "40px",
                              position: "absolute",
                              left: "235px",
                              top: "-30px",
                              zIndex: "-0.9",
                            }}
                          />
                          <img
                            id="pressure-meter"
                            loading="lazy"
                            src={pressure_meter}
                            alt=""
                            style={{
                              height: "40px",
                              width: "40px",
                              position: "absolute",
                              left: "320px",
                              top: "5px",
                              zIndex: "-0.9",
                            }}
                          />
                          {/* <img id="pressure-meter" src={pressuremeter} alt="" />
                                         <img id="water-meter" src={Watermeter} alt="" /> */}
                          {/*<img id="antena_pole" src={antena_pole} alt="" />
                                            <img id="antena_pole" src={antenapole} alt="" />
                                            <img id="Main_line_red" src={mainLine} alt="" />
                                            <img id="Concrete_Bed" src={Concrete_Bed} alt="" />
                                            <img id="pressure-meter" src={pressuremeter} alt="" />
                                            <img id="water-meter" src={Watermeter} alt="" />*/}
                          <img
                            id="Main_line_red2"
                            loading="lazy"
                            src={mainlinered}
                            alt=""
                          />
                          <img
                            id="main_pipeline"
                            loading="lazy"
                            src={mainpipleline}
                            alt=""
                          />
                          {/* <img id="Main_line_red" src={mainLine} alt="" style={{
                                                        zIndex: 2,
                                                        height: '350px',
                                                        width: '200px',
                                                        position: 'absolute',
                                                        transform: 'translate(-109px, -140px)',
                                                    }} />*/}
                          {numberOfValve.map((valve: any, index: any) => (
                            <ValveCompponent data={valve} index={index} chackData={chackData} />
                          ))}

                          <img
                            id="Concrete_Bed"
                            loading="lazy"
                            src={ConcreteBed}
                            alt=""
                          />
                        </div>
                      )}
                    </div>

                    <div className="col-md-3 cardc  ">
                      <div className="card b-r-1" style={{ width: "100%" }}>
                        <div
                          className="card-header px-3 py-1  h-50"
                          style={gradientStyle}
                        >
                          <div className="float-left">
                            <h6
                              className="card-title mb-0"
                              style={{ color: "GrayText" }}
                            >
                              Details
                            </h6>
                          </div>
                          <div className="float-right text-end">
                            <span>
                              {selectedPfcmd === "PFCMD1" &&
                              subChakData[0]?.dateTime
                                ? format(
                                    new Date(subChakData[0]?.dateTime),
                                    "yyyy-MM-dd HH:mm:ss",
                                  )
                                : selectedPfcmd === "PFCMD2" &&
                                    subChakData[1]?.dateTime
                                  ? format(
                                      new Date(subChakData[1]?.dateTime),
                                      "yyyy-MM-dd HH:mm:ss",
                                    )
                                  : selectedPfcmd === "PFCMD3" &&
                                      subChakData[2]?.dateTime
                                    ? format(
                                        new Date(subChakData[2]?.dateTime),
                                        "yyyy-MM-dd HH:mm:ss",
                                      )
                                    : selectedPfcmd === "PFCMD4" &&
                                        subChakData[3]?.dateTime
                                      ? format(
                                          new Date(subChakData[3]?.dateTime),
                                          "yyyy-MM-dd HH:mm:ss",
                                        )
                                      : data.dateTime
                                        ? format(
                                            new Date(data.dateTime),
                                            "yyyy-MM-dd HH:mm:ss",
                                          )
                                        : "N/A"}
                            </span>
                          </div>
                        </div>
                        <div className="card-body p-0 chackcard">
                          <table className=" table  table-hover table-striped custom-table  chackcard  ">
                            <tbody className="chackcard">
                              <tr>
                                <th> Chak Name</th>
                                <td>
                                  {" "}
                                  {(() => {
                                    const displayName =
                                      selectedPfcmd === "PFCMD1"
                                        ? subChakData[0]?.chackName
                                        : selectedPfcmd === "PFCMD2"
                                          ? subChakData[1]?.chackName
                                          : selectedPfcmd === "PFCMD3"
                                            ? subChakData[2]?.chackName
                                            : selectedPfcmd === "PFCMD4"
                                              ? subChakData[3]?.chackName
                                              : data.chackName;

                                    return displayName && displayName.length > 4
                                      ? displayName.slice(0, 4) + "..."
                                      : displayName;
                                  })()}
                                </td>
                              </tr>
                              <tr>
                                <td>Chak Area</td>
                                <td>
                                  {selectedPfcmd === "PFCMD1"
                                    ? subChakData[0]?.chackArea
                                    : selectedPfcmd === "PFCMD2"
                                      ? subChakData[1]?.chackArea
                                      : selectedPfcmd === "PFCMD3"
                                        ? subChakData[2]?.chackArea
                                        : selectedPfcmd === "PFCMD4"
                                          ? subChakData[3]?.chackArea
                                          : data.chackArea}
                                </td>
                              </tr>
                              <tr>
                                <td>Duty</td>
                                <td>
                                  {selectedPfcmd === "PFCMD1"
                                    ? subChakData[0]?.duty
                                    : selectedPfcmd === "PFCMD2"
                                      ? subChakData[1]?.duty
                                      : selectedPfcmd === "PFCMD3"
                                        ? subChakData[2]?.duty
                                        : selectedPfcmd === "PFCMD4"
                                          ? subChakData[3]?.duty
                                          : data.duty}
                                </td>
                              </tr>
                              <tr>
                                <td>Roms Mode</td>
                                <td>
                                  {selectedPfcmd === "PFCMD1"
                                    ? subChakData[0]?.romsAuto
                                      ? "auto"
                                      : "manual"
                                    : selectedPfcmd === "PFCMD2"
                                      ? subChakData[1]?.romsAuto
                                        ? "auto"
                                        : "manual"
                                      : selectedPfcmd === "PFCMD3"
                                        ? subChakData[2]?.romsAuto
                                          ? "auto"
                                          : "manual"
                                        : selectedPfcmd === "PFCMD4"
                                          ? subChakData[3]?.romsAuto
                                            ? "auto"
                                            : "manual"
                                          : data.romsAuto
                                            ? "manual"
                                            : "auto"}
                                </td>
                              </tr>
                              <tr>
                                <td>Flow Rate</td>
                                <td>
                                  {selectedPfcmd === "PFCMD1"
                                    ? subChakData[0]?.flowRate
                                    : selectedPfcmd === "PFCMD2"
                                      ? subChakData[1]?.flowRate
                                      : selectedPfcmd === "PFCMD3"
                                        ? subChakData[2]?.flowRate
                                        : selectedPfcmd === "PFCMD4"
                                          ? subChakData[3]?.flowRate
                                          : data.flowRate}
                                </td>
                              </tr>
                              <tr>
                                <td>Today Volume</td>
                                <td>
                                  {selectedPfcmd === "PFCMD1"
                                    ? subChakData[0]?.todayVolume
                                    : selectedPfcmd === "PFCMD2"
                                      ? subChakData[1]?.todayVolume
                                      : selectedPfcmd === "PFCMD3"
                                        ? subChakData[2]?.todayVolume
                                        : selectedPfcmd === "PFCMD4"
                                          ? subChakData[3]?.todayVolume
                                          : data.todayVolume}
                                </td>
                              </tr>
                              <tr>
                                <td>Pressure</td>
                                <td>
                                  {selectedPfcmd === "PFCMD1"
                                    ? subChakData[0]?.pressure
                                    : selectedPfcmd === "PFCMD2"
                                      ? subChakData[1]?.pressure
                                      : selectedPfcmd === "PFCMD3"
                                        ? subChakData[2]?.pressure
                                        : selectedPfcmd === "PFCMD4"
                                          ? subChakData[3]?.pressure
                                          : data.pressure}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ))}
        </div>
      )}
    </>
  );
};

export default ChackComponent;
